import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import { getStoredFilter, updateStoredFilterItems } from './filter-common';
import Stack from 'react-bootstrap/Stack';
import debounce from 'lodash.debounce';
import { MdOutlineCancel, MdOutlineSearch } from 'react-icons/md';

export function FilterSelection({ filterId: filterKey, filterChangedCallback, aggrid = true }) {
  const [allChecked, setAllChecked] = useState(true);
  const [filterSelections, setFilteredSelections] = useState([] | undefined);
  const [selections, setSelections] = useState([] | undefined);
  const [labelClassname, setLabelClassname] = useState('');
  const searchQueryRef = useRef();

  const searchMouseEnter = (e) => {
    const event = { ...e };
    event.target.style.cursor = 'pointer';
  };

  const searchMouseLeave = (e) => {
    const event = { ...e };
    event.target.style.cursor = '';
  };

  const updateStoredFilters = (filteredSelections) => {
    const distinctFilterValue = filteredSelections.map((item) => {
      return item.lcValue;
    });
    const updatedSelections = selections.map((item) => {
      if (distinctFilterValue.indexOf(item.lcValue) === -1) {
        return { ...item, selected: false };
      }
      return { ...item };
    });
    updateStoredFilterItems(filterKey, updatedSelections);
    filterChangedCallback(filterKey);
  };

  const doSelectionFilter = debounce((event) => {
    const query = event.target.value;
    if (!query) {
      const resetSelections = [...selections];
      resetSelections.forEach((selection) => {
        selection.selected = true;
      });
      return setFilteredSelections(resetSelections);
    }

    const lcQuery = query.toLowerCase();

    const updatedSelections = selections.filter((item) => {
      item.selected = !!item.lcValue.includes(lcQuery);
      return item.selected;
    });
    setFilteredSelections(updatedSelections.length > 0 ? updatedSelections : undefined);
    updateStoredFilters(updatedSelections);
  }, 500);

  const resetSearch = () => {
    searchQueryRef.current.value = '';
    setAllChecked(true);
    const updatedFilterSelections = [...selections];
    updatedFilterSelections.forEach((selection) => {
      selection.selected = true;
    });
    setFilteredSelections(updatedFilterSelections);
    updateStoredFilters(updatedFilterSelections);
  };

  const allChanged = (event) => {
    const checked = event.target.checked;
    setAllChecked(checked);
    const updatedFilterSelections = [...filterSelections];
    updatedFilterSelections.forEach((selection) => {
      selection.selected = checked;
    });
    setFilteredSelections(updatedFilterSelections);
    updateStoredFilters(updatedFilterSelections);
  };

  const disableItem = (index) => {
    let nSelected = 0;
    filterSelections.forEach((selection) => {
      if (selection.selected) {
        nSelected++;
      }
    });

    if (nSelected === 1 && filterSelections[index].selected) {
      return true;
    }
  };

  const selectionChanged = (event, item) => {
    item.selected = event.target.checked;
    let all = true;
    const updatedFilterSelections = [...filterSelections];
    for (const selection of updatedFilterSelections) {
      if (!selection.selected) {
        all = false;
        break;
      }
    }
    setFilteredSelections(updatedFilterSelections);
    setAllChecked(all);
    updateStoredFilters(updatedFilterSelections);
  };

  useEffect(() => {
    const filter = getStoredFilter(filterKey);
    setAllChecked(filter.allSelected);
    setSelections(filter.items);
    setFilteredSelections(filter.items);
    if (!aggrid) {
      setLabelClassname('ag-filter');
    }
  }, []);

  return (
    <Container className="pt-1 pb-1 justify-content-start">
      <Form className="pt-2">
        <Form.Check
          style={{ minWidth: '15ch' }}
          className={labelClassname}
          type="checkbox"
          id="all"
          label="Select All"
          disabled={allChecked}
          checked={allChecked}
          onChange={allChanged}
        />
      </Form>
      <Stack direction="horizontal">
        <Stack direction="horizontal" className="p-1 w-100">
          <Form.Control
            ref={searchQueryRef}
            className="p-1 text-smaller flex-grow-1"
            type="text"
            placeholder="Search"
            onChange={doSelectionFilter}
          />
          <div className="ps-2">
            {searchQueryRef?.current?.value?.length > 0 ? (
              <MdOutlineCancel
                size="2em"
                color="#0f4f73"
                onMouseEnter={searchMouseEnter}
                onMouseLeave={searchMouseLeave}
                onClick={resetSearch}
              />
            ) : (
              <MdOutlineSearch size="2em" color="#0f4f73" />
            )}
          </div>
        </Stack>
      </Stack>
      <hr className="mt-2" />
      {filterSelections?.length &&
        filterSelections.map((item, index) => (
          <Form.Check
            className={labelClassname}
            type="checkbox"
            key={index}
            id={index}
            label={item.value}
            disabled={disableItem(index)}
            checked={filterSelections[index].selected}
            onChange={(event) => {
              selectionChanged(event, item);
            }}
          />
        ))}
    </Container>
  );
}
